<template>
  <div class="thumbnail-generator">
    <video
      v-if="hasReceivedFile"
      ref="video"
      :width="width"
      :height="height"
      @loadedmetadata="setTimeCode"
      @loadeddata="generateThumbnail"
    >
      <source ref="source">
    </video>

    <canvas
      v-if="hasReceivedFile"
      ref="canvas"
      :width="width"
      :height="height"
    >
    </canvas>
  </div>
</template>

<script>
const THUMB_WIDTH = 768;
const THUMB_HEIGHT = 432;
const THUMB_TIME_CODE = 3; // 3 seconds after the beginning
const THUMB_FILE_TYPE = 'image/jpeg';

export default {
  name: "ThumbnailGenerator",
  props: {
    file: File,
  },
  data() {
    return {
      width: THUMB_WIDTH,
      height: THUMB_HEIGHT,
      thumbnailBlob: null,
    };
  },
  computed: {
    hasReceivedFile() {
      return (this.file !== null) && (this.file !== undefined);
    }
  },
  methods: {
    startThumbnailGeneration() {
      const {video, source} = this.$refs;
      source.src = URL.createObjectURL(this.file);
      video.load();
    },
    setTimeCode() {
      const {video} = this.$refs;
      video.currentTime = THUMB_TIME_CODE;
    },
    generateThumbnail() {
      const {video, canvas} = this.$refs;
      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(video, 0, 0, THUMB_WIDTH, THUMB_HEIGHT);

      if (!canvas.toBlob) {
        const err = new Error('Canvas.toBlob() is not available');
        this.$emit('error', err);
      } else if (!this.isDecodedSuccessfully(ctx)) {
        const err = new Error('Unable to decode the video');
        this.$emit('error', err);
      } else {
        canvas.toBlob(blob => {
          this.thumbnailBlob = blob;
          this.$emit('completed');
        }, THUMB_FILE_TYPE);
      }
    },
    isDecodedSuccessfully(ctx) {
      const imageData = ctx.getImageData(0, 0, THUMB_WIDTH, THUMB_HEIGHT);
      let r = 0, g = 0, b = 0;
      for (var i = 0; i < imageData.data.length; i += 4) {
        r += imageData.data[i];     // red
        g += imageData.data[i + 1]; // green
        b += imageData.data[i + 2]; // blue
      }

      // When unsupported codec is passed, it'll give us all black pixels.
      // Using that as a condition.
      return !(r + g + b === 0);
    },
  },
}
</script>

<style scoped lang="scss">
  .thumbnail-generator {
    display: none;
  }
</style>
